import { createRouter, createWebHistory } from 'vue-router'
import homePage from '@/components/HomePage.vue'
import Login from '@/components/Login.vue'
import RegisterByPhone from '@/components/RegisterByPhone.vue'
import RegisterByMail from '@/components/RegisterByMail.vue'
import UserInfo from '@/components/UserInfo.vue'
import RetrievePassword from '@/components/RetrievePassword.vue'
import UpdatePassword from '@/components/UpdatePassword.vue'
import { setFavicon } from '@/utils/setFavicon.js'
import RechargeCenter from '@/components/RechargeCenter.vue'
import Recharge from '@/components/Recharge.vue'
import CheckAI from '@/components/plagiarism.vue'

const router = createRouter({
    // eslint-disable-next-line no-undef
    history: createWebHistory(process.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            component: homePage
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/register/phone',
            name: 'RegisterByPhone',
            component: RegisterByPhone
        },
        {
            path: '/register/mail',
            name: 'RegisterByMail',
            component: RegisterByMail
        },
        {
            path: '/user',
            name: 'UserInfo',
            component: UserInfo
        },
        {
            path: '/retrieve-password',
            name: 'RetrievePassword',
            component: RetrievePassword
        },
        {
            path: '/change-password',
            name: 'UpdatePassword',
            component: UpdatePassword
        },
        {
            path: '/rechargeCenter',
            name: 'RechargeCenter',
            component: RechargeCenter
        },
        {
            path: '/recharge',
            name: 'Recharge',
            component: Recharge
        },
        {
            path: '/detection',
            name: 'CheckAI',
            component: CheckAI
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = 'ZeroAI'
    }
    // 动态更新favicon
    if (to.meta && to.meta.favicon) {
        setFavicon(`/${to.meta.favicon}`)
    } else {
        setFavicon('/logo1.svg') // 引用默认图标
    }
    next()
})
export default router
